"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSymbol = void 0;
exports.isSymbol = (value) => typeof value === "symbol";
//# sourceMappingURL=is-symbol.js.map